"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationError_1 = require("auto-widget-framework/src/Error/ValidationError");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
class BaseFormValidator {
    constructor(formElement, validationConfig, validationCriteria, validator) {
        this.formElement = formElement;
        this.validationConfig = validationConfig;
        this.validationCriteria = validationCriteria;
        this.validator = validator;
    }
    /**
     * @inheritDoc
     */
    static create(formElement, validationConfig, container) {
        return new this(formElement, validationConfig, container.get("validation_criteria"), container.get("validator"));
    }
    /**
     * @inheritDoc
     */
    validate() {
        return Promise.resolve().then(() => {
            // @TODO: Implement properly to extract error types.
            // @TODO: Value sent through param should be validated as it can be processed.
            const valid = this.validator.validateInputs(this.validationConfig, false, this.formElement);
            return valid ? null : new ValidationError_1.default(`Invalid form`, {}, this.formElement);
        });
    }
    /**
     * @inheritDoc
     */
    validateField(inputName, value) {
        return Promise.resolve().then(() => {
            // @TODO: Implement properly to extract error types.
            // @TODO: Value sent through param should be validated as it can be processed.
            const element = this.formElement.querySelector(`[name="${inputName}"]`);
            const validations = this.validationConfig.filter((rule) => {
                return this.formElement.querySelector(rule.inputId) === element;
            }).map((rule) => this.validator.validateWithoutTriggeringErrors(rule, this.formElement));
            return validations.indexOf(false) === -1 ? null : [];
        });
    }
}
exports.default = BaseFormValidator;
Mixin_1.default(BaseFormValidator, IContainerInjection_1.default);
